import { z } from 'zod';
/** Submission intake — patient's completed form; opens the clinician sign-off task. */
export const submissionSubmitSchema = z.object({
    data: z.record(z.unknown()).optional(), // encrypted PHI payload
    assignToUserId: z.string().uuid().optional(), // route the clinician task
});
/**
 * Draft save — stores partial answers but is NOT a final attestation: it does
 * NOT satisfy the sign-off obligation (README §2), so the reminder/escalation
 * clock keeps running.
 */
export const submissionDraftSchema = z.object({
    data: z.record(z.unknown()).optional(),
});
/**
 * Sign a task. `coSign` opens the NEXT co-sign task instead of finalizing —
 * assigned to `coSignUserId` when given, else (clinician stage) the signer's
 * org-chart supervisor. Any stage may request a further co-sign, so a
 * submission can chain an unbounded number of signatures (4+ supported).
 */
export const signoffSignSchema = z.object({
    coSign: z.boolean().optional(),
    coSignUserId: z.string().uuid().optional(),
});
export const signoffReassignSchema = z.object({
    assignedUserId: z.string().uuid(),
});
//# sourceMappingURL=signoff.js.map